import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PROMOTION_CAMPAIGN_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getPromotionCampaignNotificationAction = createAsyncThunk(
    'price/getPromotionCampaignNotificationAction',
    async (promotionCampaignId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PROMOTION_CAMPAIGN_PATH }/${ promotionCampaignId }/notification`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getPromotionCampaignNotificationSlice = createSlice({
    name: 'getPromotionCampaignNotificationsSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(getPromotionCampaignNotificationAction.pending, () => STATE__API__STARTED);
        builder.addCase(getPromotionCampaignNotificationAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getPromotionCampaignNotificationAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getPromotionCampaignNotificationState = (state) => state.price.getPromotionCampaignNotification;
export default getPromotionCampaignNotificationSlice.reducer;